var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"act-modal",style:(_vm.boxStyle)},[_c('div',{staticClass:"act-modal-dialog"},[(_vm.tpl.props.fixedMask)?_c('div',{style:(_vm.fixedMaskStyle)}):_vm._e(),_vm._v(" "),_c('div',{class:_vm.dialogPositionClass},[(_vm.tpl.props.closable)?_c('a',{staticClass:"close j_close_btn",attrs:{"href":"javascript:void(0);","title":"关闭"},on:{"click":_vm.onClick}}):_vm._e(),_vm._v(" "),_c('children-renderer')],1)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{}!./~/vue-loader/lib?{}!./~/iview-loader?{"prefix":true}!./src/render/index.vue?vue&type=template&id=77f5cb08&scoped=true&
// module id = 469
// module chunks = 0